<template>
    <div>
        <!-- <solicitudVerano v-if="solicitud" @edicion="edicion"/> -->
        <solicitarIdiomas @leemos="leemos" v-shos="leidos" v-if="abierto"/>
        <div v-else>
            <h3 class="text-center"><br>PLAN DE VACACIONES CERRADO</h3>
        </div>
    </div>
</template>

<script>

import solicitarIdiomas from '@/components/solicitar-idiomas.vue'

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'idiomas',
  components: {
      solicitarIdiomas

  },

  data() {
    return {
        plan: 'IDIOMAS',
        planId: 8,

        SS: {},

        abierto: false,
        leidos: false,

    }
  },

  created() {
  },

  mounted() {
    if (!this.logueado) {
        this.$router.push('/');
        return;
    }
    this.leemos();
  },

  computed: {
    ...mapState(['auth','EMP','ASI','SOL']),

    logueado() {
        return this.auth.logueado;
    },
    usuario() {
        return this.$store.state.auth.user;
    },

    solicitud() {
        //alert(this.SS.id);
        //return (this.SS.id==undefined || Number(this.SS.id>0));
        return (this.SS.id!='0'||this.editamos);
    },

  },

  methods: {
       ...mapMutations(['loading','alerta','modal']),
       ...mapActions(['exec']),

        async leemos0() {
            this.modal({tit: this.plan, msg: 'Plan de Vacaciones CERRADO'});
            this.$router.push('/inicio');
        },

        async leemos() {
            var args={ token: this.auth.token, fnt:'get', plan: this.planId };
            let r=await this.exec({api:'solicitud', arg: args });

            if (r.error) {
                let m=r.datos;
                if (m=='Error Usuario (1)') {
                    m='La sesion iniciada se cerrará. Ha superado el tiempo de inactividad de su sesión.<br>Debe acceder de nuevo.';

                    this.$store.commit('login_off');
                    this.$router.push('/');
                } else
                    this.$router.push('/inicio');

                //mensaje error modal ... mostrar r.datos
                this.modal({tit: this.plan, msg: m});

                return;
            }
            console.log('***** idiomas.leemos',r.datos);

            this.abierto=true;

            //guardamos datos
            this.$store.state.EMP=r.datos[0]; //Object.values(r.datos[0]);
            this.$store.state.ASI=Object.values(r.datos[1]);
            //this.$store.state.SOL=r.datos[2];
            this.SS=r.datos[2];
            //this.SS=Object.values(r.datos[2]);
            this.$store.state.SOL=this.SS;

            this.leidos=true;

            return true;
        },

   }

}
</script>